import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

/** The date picker hands back the wall-clock time picked in the account's
 * timezone ("2026-10-23T10:00:00", no offset). Read in the browser's own
 * timezone, a campaign set for 10:00 Istanbul time from a UTC browser would
 * start at 13:00.
 */
export const campaignInstant = (value: Date | string, tz?: string) => {
  const hasOwnInstant =
    value instanceof Date || /(?:Z|[+-]\d{2}:?\d{2})$/i.test(value);

  return hasOwnInstant || !tz ? dayjs(value) : dayjs.tz(value, tz);
};

/** In the account's timezone, so it matches what the date picker shows */
export const formatCampaignTime = (
  value: Date | string | dayjs.Dayjs | undefined,
  tz?: string,
) => {
  if (!value) {
    return "";
  }

  const date = dayjs(value as any);

  return (tz ? date.tz(tz) : date).format("DD MMM YYYY, HH:mm");
};
